'use client';

import * as React from 'react';
import { useAppSelector } from '@/store/hooks';
import { getDrawerContent } from '@/store/reducers/drawer-content-slice';
import {
  Alert,
  Button,
  Card,
  CardContent,
  CircularProgress,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
} from '@mui/material';
import { Box, Stack } from '@mui/system';

import { PlayerDetailsTable } from './player-details-table';
import { TransactionDetailsTable } from './transaction-details-table';

export function TransactionDetailsTab(): React.JSX.Element {
  const { TRANSACTION_DETAILS: data } = useAppSelector(getDrawerContent);

  //   const fetchAccountData = async (): Promise<void> => {
  //     try {
  //       const response = await fetch(`/api/devops/cf-accounts/list`, {
  //         method: 'post',
  //         body: JSON.stringify({ cfAccountCode: CF_ACCOUNT_DETAILS }),
  //       });
  //       const result: OperatorCfAccountListResponseDto = await response.json();
  //       if (response.ok && result.success && result.data) {
  //         setCfAccountData(result.data[0]);
  //       }
  //     } catch (e) {
  //       // empty block
  //     }
  //   };

  //   React.useEffect(() => {
  //     void fetchAccountData();
  //   }, []);

  return (
    <Stack direction="column">
      {!data ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 6 }}>
          <CircularProgress color="primary" size={38} />
        </Box>
      ) : (
        <Stack gap={2}>
          <Card>
            <CardContent>
              <Stack direction="column" gap={4}>
                <TransactionDetailsTable transactionData={data} />

                {/* <Typography variant="h6">Change Status</Typography>
                <Stack direction={{ xs: 'column', lg: 'row' }} gap={1.5}>
                  <Select fullWidth>
                    <MenuItem>Reason</MenuItem>
                  </Select>
                  <OutlinedInput fullWidth placeholder="Admin Note" />
                  <Button variant="contained" color="success" sx={{ flexShrink: 0 }}>
                    Save Changes
                  </Button>
                </Stack> */}

                <PlayerDetailsTable transactionData={data} />
                <Alert severity="info">
                  Click the button below will retrieve the latest transaction status from the payment provider
                </Alert>
                <Box sx={{ textAlign: 'end' }}>
                  <Button variant="contained">Check Provider Status</Button>
                </Box>
              </Stack>
            </CardContent>
          </Card>
        </Stack>
      )}
    </Stack>
  );
}
